export const variant1 = 'variant1';
export const variant2 = 'variant2';
export const variant3 = 'variant3';
export const variant4 = 'variant4';
export const variant5 = 'variant5';

export const SIDE_NAV_LAYOUT_NAVS_MOBILE_HEIGHT_HONDA = '112px';
export const SIDE_NAV_LAYOUT_NAVS_MOBILE_HEIGHT_ACURA = '112px';
